export default __webpack_public_path__ + "static/media/screenshot10.3ec96526.jpg";